import Music from './Music.vue';

export default Music;
